var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",on:{"click":_vm.homePage}},[_c('img',{attrs:{"src":("/images/logo" + _vm.logoColor)}})])}
var staticRenderFns = []

export { render, staticRenderFns }